/** Splits seconds into whole hours and minutes. */
export function hoursMinutes(seconds: number): { hours: number; minutes: number } {
  const total = Math.max(0, Math.round(seconds / 60));
  return { hours: Math.floor(total / 60), minutes: total % 60 };
}

/** "1:05:09" — a running timer. */
export function clock(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const rest = s % 60;
  return `${h}:${String(m).padStart(2, '0')}:${String(rest).padStart(2, '0')}`;
}

/**
 * Parses what people type for a duration: "1:30", "1,5", "1.5", "90m", "2h", "2ч 15м". Plain numbers are hours.
 * Returns seconds, or null when unreadable.
 */
export function parseDuration(input: string): number | null {
  const text = input.trim().toLowerCase().replace(',', '.');
  if (!text) return null;
  const clockMatch = /^(\d{1,3}):([0-5]?\d)$/u.exec(text);
  if (clockMatch) return Number(clockMatch[1]) * 3600 + Number(clockMatch[2]) * 60;
  const parts = [...text.matchAll(/(\d+(?:\.\d+)?)\s*(часов|часа|час|ч|год|h|мин|min|хв|м|m)?/gu)];
  if (
    parts.length === 0 ||
    parts
      .map((p) => p[0])
      .join('')
      .replace(/\s/gu, '') !== text.replace(/\s/gu, '')
  )
    return null;
  let seconds = 0;
  for (const [, value, unit] of parts) {
    const n = Number(value);
    if (!Number.isFinite(n)) return null;
    const isMinutes = unit !== undefined && /^(мин|min|хв|м|m)$/u.test(unit);
    seconds += isMinutes ? n * 60 : n * 3600;
  }
  return Math.round(seconds);
}
